import packageConfig from '../../package.json';

// get base path from package.json
const basePath = packageConfig.homepage

export const updateURL = (ds, dsIdx, exp, expId) => {
  let currentPage = window.location.pathname.replace(basePath, '').split("/")[1];
  // check if /kilab is in the URL, if so override currentPage
  if (basePath.includes("/kilab")) {
    // eslint-disable-next-line prefer-destructuring
    currentPage = window.location.pathname.replace(basePath, '').split("/")[2];
  }

  // check if route is experiment route - otherwise, no change is needed
  if (["quality-check", "inspect", "train", "analyze", "runs"].includes(currentPage)) {
    // encode for URI to remove emojis and other special characters
    const dsName = encodeURIComponent(ds[dsIdx].datasetName);
    const expName = encodeURIComponent(exp[expId].experimentName);
    let newUrl = `${basePath}/${currentPage}/${dsName}/${expName}`;
    if (window.location.pathname.includes("pipeline")) {
      // also get run name i.e. last item for pipeline page and add to url
      const runName = encodeURIComponent(window.location.pathname.replace(basePath, '').split("/").pop())
      newUrl = `${newUrl}/pipeline/${runName}`;
    }
    window.history.pushState(null, "", newUrl);
  }
};
export const getSelectedDatasetByRoute = () => {
  // check if user is on experiment page, if so, returns readable dataset name
  // is especially important on reload
  const pathnames = window.location.pathname.replace(basePath, '').split("/");
  if (["inspect", "train", "analyze", "runs"].includes(pathnames[1])) {
    return decodeURIComponent(pathnames[2]);
  }
  return null;
};

export const getSelectedExperimentByRoute = () => {
  // check if user is on experiment page, if so, returns readable experiment name
  // is especially important on reload
  const pathnames = window.location.pathname.replace(basePath, '').split("/");
  if (["inspect", "train", "analyze", "runs"].includes(pathnames[1])) {
    return decodeURIComponent(pathnames[3]);
  }
  return null;
};
